module.exports = __webpack_public_path__ + "static/media/1656587766_35-illustration_png.ffcb2d5f.png";